<div class="header">
  <!-- Router link here is default ["/"] -->
  <spb-logo [onlyLogoLink]="true"/>
  <div [style.flex-grow]="1"></div>
  <div style="padding-right: 4px">
    <button
      [matMenuTriggerFor]="menu"
      mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>
  <mat-menu #menu="matMenu">
    <button (click)="service.site.set('assets/renewal-test.html')" mat-menu-item>Omsättningar</button>
    <button (click)="service.site.set('assets/sparguide-test.html')" mat-menu-item>Sparguide</button>
  </mat-menu>
</div>